"use client"

import { type SelectionQueryParams } from "@/lib/centra-client/interfaces/ISelectionService"
import logger from "@/lib/logger/logger-init"
import { type CheckoutAPISelectionWithRequiredToken } from "@/types/centra/checkout-api/selection/get-selection"
import { type Result, ResultFactory } from "@/types/generic/Result"

export const removeVoucher = async (
    params: SelectionQueryParams
): Promise<Result<CheckoutAPISelectionWithRequiredToken>> => {
    try {
        const response = await fetch("/api/centra/remove-voucher", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(params)
        })

        const result = await response.json()

        if (!response.ok || !result.success) {
            const errorMessage = result.error || "Failed to remove voucher"
            logger.error(errorMessage)
            return ResultFactory.failure<CheckoutAPISelectionWithRequiredToken>(
                new Error(errorMessage)
            )
        }

        return ResultFactory.success<CheckoutAPISelectionWithRequiredToken>(result.data)
    } catch (error) {
        logger.error("Unexpected error in removeVoucher", error)
        return ResultFactory.failure<CheckoutAPISelectionWithRequiredToken>(
            error instanceof Error ? error : new Error("Failed to remove voucher")
        )
    }
}
